import { StyleSheet } from 'react-native'

export const landingHeaderControlsStyles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
})
